module.exports = __webpack_public_path__ + "img/yellow-line-vertical.d63eabd3.svg";